import { render, staticRenderFns } from "./GoodDesigner.vue?vue&type=template&id=6ed4ded3&scoped=true"
import script from "./GoodDesigner.vue?vue&type=script&lang=js"
export * from "./GoodDesigner.vue?vue&type=script&lang=js"
import style0 from "./GoodDesigner.vue?vue&type=style&index=0&id=6ed4ded3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4ded3",
  null
  
)

export default component.exports